import { ALL_ALLERGENS, ALL_LABELS } from '../utils/allergenParser';
import { useTranslation } from 'react-i18next';

export default function AllergenSection({ allergens = [], labels = [], ingredients_text = '', onAllergenToggle, onLabelToggle, onIngredientsChange, onOCR, scanning }) {
  const { t } = useTranslation();
  const toggleStyle = (active) => ({
    display: 'inline-flex', alignItems: 'center', gap: 4,
    padding: '5px 10px', borderRadius: 999, fontSize: 12, fontWeight: 500,
    cursor: 'pointer', border: 'none', fontFamily: 'DM Sans, sans-serif',
    background: active ? 'oklch(55% 0.22 25 / 20%)' : 'var(--bg-elevated)',
    color: active ? 'oklch(55% 0.22 25)' : 'var(--fg-3)',
    outline: active ? '1px solid oklch(55% 0.22 25 / 40%)' : 'none',
  });
  const labelStyle = (active) => ({
    ...toggleStyle(active),
    background: active ? 'oklch(56% 0.18 152 / 20%)' : 'var(--bg-elevated)',
    color: active ? 'oklch(56% 0.18 152)' : 'var(--fg-3)',
    outline: active ? '1px solid oklch(56% 0.18 152 / 40%)' : 'none',
  });
  return (
    <div style={{ background: 'var(--bg-elevated)', borderRadius: 12, padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--fg-2)', fontFamily: 'DM Sans, sans-serif' }}>🧪 {t('allergens.title')}</p>
        <button onClick={onOCR} disabled={scanning} style={{
          padding: '6px 12px', borderRadius: 8, border: 'none', cursor: scanning ? 'default' : 'pointer',
          background: 'var(--brand)', color: 'white', fontSize: 12, fontWeight: 600, fontFamily: 'DM Sans, sans-serif',
          opacity: scanning ? 0.6 : 1,
        }}>
          {scanning ? `⏳ ${t('allergens.scanning')}` : `📷 ${t('allergens.scanPackaging')}`}
        </button>
      </div>
      <div>
        <p style={{ fontSize: 11, color: 'var(--fg-4)', fontFamily: 'DM Sans, sans-serif', marginBottom: 6 }}>{t('allergens.sectionAllergens')}</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {ALL_ALLERGENS.map(a => (
            <button key={a.key} type="button" onClick={() => onAllergenToggle(a.key)} style={toggleStyle(allergens.includes(a.key))}>
              {a.emoji} {t(`allergens.${a.key}`)}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p style={{ fontSize: 11, color: 'var(--fg-4)', fontFamily: 'DM Sans, sans-serif', marginBottom: 6 }}>{t('allergens.sectionLabels')}</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {ALL_LABELS.map(l => (
            <button key={l.key} type="button" onClick={() => onLabelToggle(l.key)} style={labelStyle(labels.includes(l.key))}>
              {l.emoji} {t(`allergens.${l.key}`)}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p style={{ fontSize: 11, color: 'var(--fg-4)', fontFamily: 'DM Sans, sans-serif', marginBottom: 6 }}>{t('allergens.sectionIngredients')}</p>
        <textarea value={ingredients_text || ''} onChange={e => onIngredientsChange(e.target.value)}
          rows={3} placeholder={t('allergens.ingredientsPlaceholder')}
          style={{ width: '100%', background: 'var(--bg-card)', border: '1px solid var(--border-subtle)', borderRadius: 8, padding: '8px 10px', fontSize: 12, color: 'var(--fg-1)', fontFamily: 'DM Mono, monospace', resize: 'vertical' }} />
      </div>
    </div>
  );
}
